import { useDarkMode } from '@/composables/useDarkMode';

export type SimpleColorKey = 'green' | 'red' | 'orange' | 'grey';

export const useColor = () => {
  const darkMode = useDarkMode();
  /**
   * Generate color for success - error range, input values 0..100
   *
   * @param valInPercent
   * @returns {string}
   */
  const getColorOnColorScale = (valInPercent: number): string => {
    let r: number;
    let g: number;
    const b = 50;

    if (valInPercent < 50) {
      r = 180;
      g = Math.round(3.6 * valInPercent);
    } else {
      g = 180;
      r = Math.round(360 - 3.6 * valInPercent);
    }

    const h = r * 0x10000 + g * 0x100 + b;
    return '#' + ('000000' + h.toString(16)).slice(-6);
  };

  /**
   * Returns a background CSS class for ag‑Grid rows based on a simple color key
   * and current theme (light/dark).
   *
   * Keys: green | red | orange
   * Resulting classes:
   *  - row-bg-<key>-light
   *  - row-bg-<key>-dark
   *
   * The actual HEX colors are defined globally in SCSS (ag-grid-custom.scss).
   */
  const getRowBgClass = (key: SimpleColorKey): string => {
    const theme = darkMode.isActive.value ? 'dark' : 'light';
    return `row-bg-${key}-${theme}`;
  };

  return {
    getColorOnColorScale,
    getRowBgClass,
  };
};
